import React, { useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import CustomModal from "../../../../components/main_comps/custom_modal";
import { Document, Page } from "react-pdf";

export function getFileExtension(filename) {
  var ext = /^.+\.([^.]+)$/.exec(filename);
  return ext == null ? "" : ext[1];
}
const Container = ({ title, value, onClick, url }) => {
  return (
    <div style={{ marginBottom: "20px" }}>
      <label
        style={{
          color: "#6C6B6B",
          fontSize: "12px",
          fontWeight: "500",
        }}
      >
        {title}
      </label>
      <div
        style={{
          width: "40%",
          maxWidth: "400px",
          minWidth: "300px",
          backgroundColor: "rgba(111, 108, 255, 0.05)",
          height: "55px",
          display: "flex",
          padding: "0px 15px",
          boxSizing: "border-box",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: 5,
          cursor: "pointer",
        }}
        onClick={() => onClick(url, title)}
      >
        <p style={{ color: "#38369C" }}>{title}</p>
        <AiOutlineEye color="#38369C" size="20" />
      </div>
    </div>
  );
};

const ClientsDocument = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);
  const [url, seturl] = useState("");
  const [fiieName, setfiieName] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  return (
    <div
      style={{
        marginLeft: "2%",
        display: "flex",
        flexWrap: "wrap",
        gap: "0px 100px",
      }}
    >
      <Container
        title="Pan card"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.panCardUrl}
      />
      <Container
        title="Onboarding Docs(UPI)"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.upiRequestForm}
      />

      <Container
        title="Cancelled Cheque"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.cancelledChequeUrl}
      />
      <Container
        title="NDA Certificate"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.ndaCertificateUrl}
      />
      <Container
        title="Incorporation Certifcate"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.incorporationCertificateUrl}
      />
      <Container
        title="Signed SLA"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.uploadSignedSlaUrl}
      />
      {/*SoleProprietorship && Partnership  */}
      {(data?.businessType === "SoleProprietorship" ||
        data?.businessType === "Partnership") && (
        <>
          <Container
            title="Udyog Aadhar/ Udyam Aadhar"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.udyogCertificateUrl}
          />
          <Container
            title="Aadhar"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.aadharUrl}
          />
          <Container
            title="Agreement"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.agreementUrl}
          />
          <Container
            title="Merchant Onboarding"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.merchantOnboardingUrl}
          />
        </>
      )}
      {/* PARTNERSHIP */}
      {data?.businessType === "Partnership" && (
        <>
          <Container
            title="Partnership deeds"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.partnershipDeedsUrl}
          />
        </>
      )}
      {/* PUBLIC and PRIVATE LIMITED */}
      {(data?.businessType === "Public" ||
        data?.businessType === "PrivateLimited") && (
        <>
          <Container
            title="Merchant Approval Form"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.merchantApprovalFormUrl}
          />

          <Container
            title="Gst Certificate"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.gstCertificateUrl}
          />
          <Container
            title=" GST Certificate"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.gstCertificateUrl}
          />
          <Container
            title=" COI Certificate"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.incorporationCertificateUrl}
          />
          <Container
            title="Memorandum of Association"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.memorandumOfAssociationUrl}
          />
          <Container
            title="KYC of the Signing authority"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.kycSigningAuthorityUrl}
          />
          <Container
            title="Article of Association"
            onClick={(data, file) => {
              setOpenModal(true);
              seturl(data);
              setfiieName(file);
            }}
            url={data?.articleOfAssociationUrl}
          />
        </>
      )}

      {openModal && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
          open={openModal}
          isBackRequired={false}
          headerTitle={fiieName}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          {getFileExtension(url) === "pdf" || "xlsx" ? (
            <>
              <iframe
                sandbox="allow-downloads"
                src={url}
                frameborder="0"
                height="500px"
                width="100%"
              ></iframe>
            </>
          ) : (
            <img
              src={url}
              sandbox="allow-downloads"
              style={{
                borderRadius: "20px",
                width: "100%",
                height: "80%",
                marginTop: "10px",
              }}
              alt="Documents"
            />
          )}
        </CustomModal>
      )}
    </div>
  );
};

export default ClientsDocument;
